// extracted by mini-css-extract-plugin
module.exports = {"dashboardButton":"Dashboard_dashboardButton__8FqD4","noDecoration":"Dashboard_noDecoration__1zrsi","container2":"Dashboard_container2__1Ky36","contact":"Dashboard_contact__1e0Xx"};